import React from "react";
import "../../styles/service-hero.css";
import "./HeroWebSection.css";

const bars = [46, 62, 54, 78, 60, 88, 72];
const bubbles = [
  { x: 18, y: 62, r: 8 }, { x: 34, y: 38, r: 13 }, { x: 52, y: 54, r: 6 },
  { x: 64, y: 26, r: 16 }, { x: 78, y: 48, r: 9 }, { x: 88, y: 30, r: 11 },
];

const HeroWebSection = () => {
  return (
    <section className="hero-web-section">
      <div className="service-hero-copy">
        <h1 className="service-hero-title">
          Maßgeschneiderte Web-Lösungen für Ihr Unternehmen
        </h1>
        <p className="service-hero-lead">
          Von der Business-Website bis zur komplexen Web-Anwendung: Wir konzipieren,
          gestalten und entwickeln performante Weblösungen, die Ihre Kunden überzeugen
          und Ihr Geschäft messbar voranbringen.
        </p>
        {/* <div className="service-hero-actions">
          <ProjektanfrageButton />
          <Link to="/case-studies" className="service-hero-secondary">
            Case Studies ansehen
          </Link>
        </div> */}
      </div>

      <div className="web-canvas" aria-hidden="true">
        <span className="web-glow web-glow-a" />
        <span className="web-glow web-glow-b" />

        <div className="web-browser">
          {/* Chrome */}
          <div className="web-browser-bar">
            <span /><span /><span />
            <div className="web-browser-url">
              <svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.9 8h-3.02a15.6 15.6 0 0 0-1.13-4.53A8.02 8.02 0 0 1 18.9 10zM12 4.06c.8 1.13 1.4 2.5 1.72 3.94h-3.44c.32-1.44.92-2.81 1.72-3.94zM4.26 12h3.02c.06 1.4.28 2.75.66 4H4.92a7.96 7.96 0 0 1-.66-4zm.66-6h3.02a15.9 15.9 0 0 0-.66 4H4.26c.1-1.42.3-2.77.66-4zm3.36 10h3.44c-.32 1.44-.92 2.81-1.72 3.94A11.6 11.6 0 0 1 8.28 16zm3.72 3.94A15.6 15.6 0 0 0 13.86 14h3.02a8.02 8.02 0 0 1-4.88 5.94zM13.86 12a15.9 15.9 0 0 0-.66-4h3.02c.36 1.23.56 2.58.66 4h-3.02z" /></svg>
              <span className="web-browser-url-text">nexite.de/analytics</span>
              <span className="web-browser-cursor" />
            </div>
          </div>

          <div className="web-browser-body">
            {/* Sidebar */}
            <div className="web-sidebar">
              <span className="web-sidebar-logo" />
              <span className="web-sidebar-item web-sidebar-item-active">
                <svg viewBox="0 0 24 24"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" /></svg>
              </span>
              <span className="web-sidebar-item">
                <svg viewBox="0 0 24 24"><path d="M3.5 18.5 9 13l4 4 8-8-1.4-1.4L13 14.2l-4-4-6.5 6.5z" /></svg>
              </span>
              <span className="web-sidebar-item">
                <svg viewBox="0 0 24 24"><path d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3z" /></svg>
              </span>
              <span className="web-sidebar-item">
                <svg viewBox="0 0 24 24"><path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-5 0-9 2.5-9 6v2h18v-2c0-3.5-4-6-9-6z" /></svg>
              </span>
            </div>

            {/* Content */}
            <div className="web-content">
              <div className="web-topbar">
                <div className="web-topbar-titles">
                  <span className="web-topbar-title" />
                  <span className="web-topbar-sub" />
                </div>
                <div className="web-avatars"><i /><i /><i /><b>+8</b></div>
              </div>

              {/* KPI-Reihe mit Sparklines */}
              <div className="web-kpis">
                {[
                  { v: "24.8k", up: true, d: "M0,16 L8,12 L16,14 L24,8 L32,10 L40,4 L48,6" },
                  { v: "3.2s", up: true, d: "M0,6 L8,8 L16,5 L24,9 L32,6 L40,11 L48,8" },
                  { v: "98.7%", up: true, d: "M0,14 L8,13 L16,10 L24,11 L32,7 L40,6 L48,3" },
                ].map((k, i) => (
                  <div className="web-kpi" key={i} style={{ "--d": `${0.15 * i}s` }}>
                    <div className="web-kpi-top">
                      <span className="web-kpi-value">{k.v}</span>
                      <span className={`web-kpi-badge ${k.up ? "up" : "down"}`}>
                        <svg viewBox="0 0 24 24"><path d="M7 14l5-5 5 5z" /></svg>
                      </span>
                    </div>
                    <span className="web-kpi-label" />
                    <svg className="web-spark" viewBox="0 0 48 18" preserveAspectRatio="none">
                      <path d={k.d} />
                    </svg>
                  </div>
                ))}
              </div>

              {/* Haupt-Area-Chart */}
              <div className="web-chart-card web-glass">
                <div className="web-chart-head">
                  <div className="web-chart-titles">
                    <span className="web-chart-cap" />
                    <span className="web-chart-value">Umsatzverlauf</span>
                  </div>
                  <div className="web-legend">
                    <span><i className="dot-accent" /></span>
                    <span><i className="dot-brand" /></span>
                  </div>
                </div>
                <div className="web-area">
                  <svg viewBox="0 0 340 120" preserveAspectRatio="none">
                    <defs>
                      <linearGradient id="webArea" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="var(--accent)" stopOpacity="0.34" />
                        <stop offset="100%" stopColor="var(--accent)" stopOpacity="0" />
                      </linearGradient>
                    </defs>
                    {/* Raster */}
                    {[24, 48, 72, 96].map((y) => (
                      <line key={y} className="web-grid" x1="0" y1={y} x2="340" y2={y} />
                    ))}
                    <path className="web-area-fill" d="M0,92 C40,70 60,78 96,54 C132,30 158,56 196,42 C236,26 262,52 300,26 C320,12 332,20 340,16 L340,120 L0,120 Z" />
                    <path className="web-area-line web-line-1" d="M0,92 C40,70 60,78 96,54 C132,30 158,56 196,42 C236,26 262,52 300,26 C320,12 332,20 340,16" />
                    <path className="web-area-line web-line-2" d="M0,104 C40,96 66,100 96,86 C130,70 156,86 196,78 C238,68 262,84 300,66 C322,54 332,60 340,58" />
                    <circle className="web-area-dot" cx="300" cy="26" r="4" />
                  </svg>
                </div>
              </div>

              {/* untere Reihe: Donut + Balken + Bubble */}
              <div className="web-lower">
                <div className="web-ring-card web-glass">
                  <div className="web-ring">
                    <svg viewBox="0 0 48 48">
                      <circle className="web-ring-track" cx="24" cy="24" r="19" />
                      <circle className="web-ring-fill" cx="24" cy="24" r="19" />
                    </svg>
                    <span className="web-ring-value">92<i>%</i></span>
                  </div>
                  <span className="web-mini-label" />
                </div>

                <div className="web-bar-card web-glass">
                  <div className="web-bar-head">
                    <span className="web-mini-cap" />
                    <span className="web-bar-total">2.4k<i>▲12%</i></span>
                  </div>
                  <div className="web-bars-plot">
                    <div className="web-bars-yaxis"><span>90</span><span>60</span><span>30</span><span>0</span></div>
                    <div className="web-bars-grid"><span /><span /><span /><span /></div>
                    <div className="web-bars">
                      {bars.map((h, i) => (
                        <span key={i}
                          className={`web-bar ${h === Math.max(...bars) ? "web-bar-peak" : ""}`}
                          style={{ "--h": `${h}%`, "--d": `${i * 0.07}s` }}>
                          {h === Math.max(...bars) && <span className="web-bar-tip">{h}</span>}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="web-bars-xaxis">
                    {["M","D","M","D","F","S","S"].map((d, i) => <span key={i}>{d}</span>)}
                  </div>
                </div>

                <div className="web-bubble-card web-glass">
                  <div className="web-bubble-head">
                    <span className="web-mini-cap" />
                    <div className="web-bubble-legend"><i /><i /><i /></div>
                  </div>
                  <svg className="web-bubble" viewBox="0 0 100 80">
                    {/* Raster */}
                    <line className="web-grid" x1="0" y1="20" x2="100" y2="20" />
                    <line className="web-grid" x1="0" y1="40" x2="100" y2="40" />
                    <line className="web-grid" x1="0" y1="60" x2="100" y2="60" />
                    <line className="web-grid" x1="25" y1="0" x2="25" y2="80" />
                    <line className="web-grid" x1="50" y1="0" x2="50" y2="80" />
                    <line className="web-grid" x1="75" y1="0" x2="75" y2="80" />
                    {/* Achsen */}
                    <line className="web-axis" x1="0" y1="80" x2="100" y2="80" />
                    <line className="web-axis" x1="0" y1="0" x2="0" y2="80" />
                    {/* Trendlinie */}
                    <path className="web-trend" d="M6,66 L92,26" />
                    {/* Bubbles: Ring + Kern */}
                    {bubbles.map((b, i) => {
                      const cls = i % 3 === 1 ? "c-brand" : i >= 4 ? "c-blue" : "c-accent";
                      return (
                        <g key={i} style={{ "--d": `${0.6 + i * 0.1}s` }}>
                          <circle className={`web-dot-ring ${cls}`} cx={b.x} cy={b.y} r={b.r + 3}
                            style={{ "--d": `${0.6 + i * 0.1}s` }} />
                          <circle className={`web-dot ${cls}`} cx={b.x} cy={b.y} r={b.r}
                            style={{ "--d": `${0.6 + i * 0.1}s` }} />
                        </g>
                      );
                    })}
                    {/* Highlight-Punkt */}
                    <circle className="web-dot-hi" cx="64" cy="26" r="4" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Terminal (dunkel) */}
        <div className="web-code-card">
          <div><span className="web-code-tag">const</span> <span className="web-code-fn">grow</span> = <span className="web-code-tag">()</span> =&gt; &#123;</div>
          <div className="web-code-indent"><span className="web-code-attr">revenue</span> += <span className="web-code-num">24.8</span>;</div>
          <div>&#125;;<span className="web-code-caret" /></div>
        </div>

        <div className="web-chip web-chip-responsive">
          <svg viewBox="0 0 24 24"><path d="M4 4h16v11H4zM2 17h20v2H2zM10 6.5h4v2h-4z" /></svg>
          <span>Responsive</span>
        </div>
        <div className="web-chip web-chip-deploy">
          <svg viewBox="0 0 24 24"><path d="M12 2 2 19h20L12 2zm0 4.6L18.3 17H5.7L12 6.6z" /></svg>
          <span>Deployed</span>
        </div>
      </div>
    </section>
  );
};

export default HeroWebSection;